import { makeStyles } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Checkbox, Paper, Popper } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { GetStatusResponse } from "../../models/basicInformation.model";

interface MultiSelectCmpPropsType {
  options?: any[];
  onChange?: any;
  label?: string;
  value?: any[];
  name?: string;
  id?: string;
  changeMultiSelect?: any;
  responseValue?: any[];
  renderOption?: any;
  inputVal?: string;
}

const icon = <CheckBoxOutlineBlankIcon />;
const checkedIcon = (
  <CheckBoxIcon
    fontSize="small"
    sx={{
      color: "#1D4A87",
      fontSize: 24,
    }}
  />
);

export default function AutocomplateCheckbox(props: MultiSelectCmpPropsType) {
  const [val, setVal] = useState<any[]>([]);
  const listboxRef = React.useRef<HTMLUListElement | null>(null);
  const scrollTopRef = React.useRef(0);
  const jsonFile = useSelector((state: any) => state.style);

  const useStyles = makeStyles((theme) => ({
    tag: {
      // backgroundColor: mainColor2,
      // backgroundColor: "#5DA76D",
      height: 24,
      position: "relative",
      zIndex: 0,
      display: "flex !important",
      alignItems: "center",
      textAlign: "center",
      borderRadius: "15px !important",
      paddingLeft: "5px !important",
      paddingRight: "5px !important",
      // left: "1.8vh !important",
      margin: "0px !important",
      marginRight: "5px !important",
    },
    root: {
      "& .MuiAutocomplete-inputRoot": {
        overflow: "hidden !important",
        flexWrap: "nowrap !important",
        textOverflow: "ellipsis !important",
        // whiteSpace: "nowrap  !important",
        position: "initial",
        color: "#000",
      },
      // "& .MuiInputBase-root": {
      //   backgroundColor: "#1B3045 !important",
      // },
    },
    inputRoot: {
      overflow: "inherit !important",
      "& .muirtl-6od3lo-MuiChip-label": {
        overflow: "inherit",
        backgroundColor: "#1B3045",
      },
      "& .muirtl-9iedg7": {
        overflow: "inherit",
      },
      "& .MuiAutocomplete-inputRoot": {
        overflow: "hidden !important",
        flexWrap: "nowrap !important",
        textOverflow: "ellipsis !important",
      },
      "&.Mui-focused fieldset": {
        position: "absolout !important",
        color: " #1D4A87 !important",
      },
      "& .muirtl-1h51icj-MuiAutocomplete-root .MuiAutocomplete-tag": {
        height: "100% !important",
        backgroundColor: "green !important",
      },
    },
    option: {
      '&[aria-selected="true"]': {
        color: "#000",
      },
      backgroundColor: "#fff",
      "& .MuiAutocomplete-tag": {
        height: "100% !important",
        backgroundColor: "green !important",
      },
    },
  }));

  const classes = useStyles();

  const handleChange = (event: object, value: any) => {
    if (listboxRef.current) {
      scrollTopRef.current = listboxRef.current.scrollTop; // ذخیره اسکرول
    }
    setVal(value);

    let partialStudentDetails = value.map((item: any, index: number) =>
      value[index].id ? value[index].id : value[index]
    );
    props?.changeMultiSelect(partialStudentDetails, value);
  };
  let isSelected: any;
  React.useEffect(() => {
    if (listboxRef.current) {
      listboxRef.current.scrollTop = scrollTopRef.current;
    }
  }, [val]);
  React.useEffect(() => {
    setVal(props.responseValue!);
  }, [props.responseValue]);

  React.useEffect(() => {
    setInputVal("");
  }, [props.inputVal === "send"]);

  const [inputVal, setInputVal] = useState<string>("");

  const handleInputChange = (
    event: React.ChangeEvent<{}>,
    newInputValue: string,
    reason: string
  ) => {
    if (reason === "input") {
      setInputVal(newInputValue);
    }
  };

  function CustomPopper(props: any) {
    return (
      <Popper
        {...props}
        modifiers={[
          {
            name: "preventOverflow",
            options: {
              boundary: "window",
            },
          },
        ]}
        sx={{
          "& .MuiAutocomplete-listbox": {
            maxHeight: "300px",
            backgroundColor: "#1B3045",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#e8eaea",
              borderRadius: "2px",
            },
          },
        }}
      >
        {" "}
        <div
          ref={(node) => {
            if (node) {
              const listbox = node.querySelector("ul");
              if (listbox) {
                (listboxRef as React.MutableRefObject<HTMLUListElement | null>).current = listbox as HTMLUListElement;
                listbox.scrollTop = scrollTopRef.current; // برگرداندن اسکرول
              }
            }
          }}
        >
          {props.children}
        </div>
      </Popper>
    );
  }
  return (
    <Autocomplete
      PopperComponent={CustomPopper}
      color={jsonFile?.muiColor}
      style={{ position: "inherit", direction: "rtl" }}
      ChipProps={{ deleteIcon: <></> }}
      disableCloseOnSelect
      popupIcon={<KeyboardArrowDownIcon />}
      value={val}
      classes={classes}
      multiple
      clearOnBlur={false}
      onChange={handleChange}
      // limitTags={0}
      id="multiple-limit-tags"
      options={props.options!}
      getOptionLabel={(option) => option?.title!}
      renderInput={(params) => (
        <TextField
          {...params}
          label={inputVal ? "" : props.label}
          color={jsonFile?.muiColor}
          InputLabelProps={{ shrink: false }}
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: "#1D4A87 !important",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1D4A87 !important",
              },
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1D4A87 !important",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1D4A87 !important",
            },
            "& .MuiInputLabel-root": {
              "&.Mui-focused": {
                color: "#1D4A87 !important",
              },
              "&:hover": {
                color: "#1D4A87 !important",
              },
              "&.MuiInputLabel-shrink": {
                color: "#1D4A87 !important",
              },
            },
          }}
        />
      )}
      disableClearable={true}
      renderOption={(optionProps, option, { selected }) => {
        const isSelected = props.responseValue?.some(
          (item) => item.id === option.id
        );
        const newOptionProps = {
          ...optionProps,
          style: {
            ...optionProps.style,
            backgroundColor: "#1B3045",
            color: "#fff",
          },
        };
        return (
          <li
            {...newOptionProps}
            style={{
              ...newOptionProps.style,
              borderBottom: "1px solid rgba(255, 255, 255, 0.25)",
              alignItems: "center",
              display: "inline-block",
              width: "100%",
            }}
          >
            <Checkbox
              sx={{
                color: "#fff",
                "& .MuiSvgIcon-root": {
                  fontSize: 24,
                  borderWidth: "0.1px",
                },
              }}
              icon={icon}
              checkedIcon={checkedIcon}
              style={{
                marginRight: 8,
                padding: "2px 5px",
                color: "#fff",
              }}
              checked={option.length > 1 ? isSelected : selected}
            />
            {option.title}
          </li>
        );
      }}
      className="maxWidthAutocomplate autocomplete-none-text"
      inputValue={inputVal}
      onInputChange={handleInputChange}
    />
  );
}
